import { render } from "./ProductLearnMore.vue?vue&type=template&id=b16df4d4&scoped=true"
import script from "./ProductLearnMore.vue?vue&type=script&lang=js"
export * from "./ProductLearnMore.vue?vue&type=script&lang=js"

import "./ProductLearnMore.vue?vue&type=style&index=0&id=b16df4d4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16df4d4"]])

export default __exports__